export default __webpack_public_path__ + "static/media/fiupload.b4445909.svg";